import React from 'react';
import { SVGWrapper } from '../SVGWrapper';
import { SEVERITY_COLORS } from '@root/utilities/pastelColors';
const NoIcon = SVGWrapper(() => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path
        d="M8.56229 1.45885C6.61234 -0.486284 3.41242 -0.486284 1.46246 1.45885C-0.487488 3.40399 -0.487488 6.59601 1.46246 8.54115C3.41242 10.4863 6.56234 10.4863 8.5123 8.54115C10.4622 6.59601 10.5122 3.40399 8.56229 1.45885ZM6.41235 7.09476L5.01238 5.69825L3.61241 7.09476L2.91243 6.39651L4.3124 5L2.91243 3.60349L3.61241 2.90524L5.01238 4.30175L6.41235 2.90524L7.11233 3.60349L5.71236 5L7.11233 6.39651L6.41235 7.09476Z"
        fill={SEVERITY_COLORS?.critical}
      />
    </svg>
  );
});
export default NoIcon;
